import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { TimeBasedSettingForAllCallersDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforallcallersdto';
import { TimeBasedSettingForAllCallersResponse } from '../../../../core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersresponse';
import { TimeBasedSettingForAllCallersRequestImpl } from '../../../../core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersrequest';
import { TimeBasedSettingForCallersGroupDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { TimeBasedSettingForCallersGroupResponse } from '../../../../core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupresponse';
import { TimeBasedSettingForCallersGroupRequestImpl } from '../../../../core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgrouprequest';
import { TimeBasedSettingForSpecificCallerDtoImpl } from '../../../../core/dto/timebasedsetting/timebasedsettingforspecificcallerdto';
import { TimeBasedSettingForSpecificCallerResponse } from '../../../../core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerresponse';
import { TimeBasedSettingForSpecificCallerRequestImpl } from '../../../../core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerrequest';
import { ListTonesDtoImpl, ListTonesDto } from '../../../../core/dto/listtones/listtonesdto';
import { ListTonesResponse } from '../../../../core/api/mytunes/listtones/listtonesresponse';
import { ListTonesRequestImpl } from '../../../../core/api/mytunes/listtones/listtonesrequest';
import { SearchToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/searchtone/searchtonedto';
import {DefaultToneDto, DefaultToneDtoImpl} from '../../../../core/dto/deafulttone/defaulttonedto';
import {DefaultToneResponse} from '../../../../core/api/defaulttone/defaulttoneresponse';
import {DefaultToneRequestImpl} from '../../../../core/api/defaulttone/defaulttonerequest';

import { SearchToneBasedOnCodeResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';
import { SearchToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest';

export interface TuneSettingsAPIModel extends APIModel
{
    getTuneSettingsForAllCaller(timeBasedSettingForAllCallersDto: TimeBasedSettingForAllCallersDtoImpl): void;
    timeBasedSettingForSpecificCallerAPI(timeBasedSettingForSpecificCallerDto: TimeBasedSettingForSpecificCallerDtoImpl): void;
    timeBasedSettingForCallersGroupAPI(timeBasedSettingForCallersGroupDto: TimeBasedSettingForCallersGroupDtoImpl): void; 
    getSearchToneBasedOnId(searchKey: string): void;
    getGroups(): void;
   defaultToneAPI(dto:DefaultToneDtoImpl):void;
}

export class TuneSettingsAPIModelImpl extends APIModelImpl implements TuneSettingsAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getTuneSettingsForAllCaller(timeBasedSettingForAllCallersDto: TimeBasedSettingForAllCallersDtoImpl): void
    {
        console.log("timeBasedSettingForAllCallerAPI() invoked ##########ALL CALLERS###############");
        
        timeBasedSettingForAllCallersDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        timeBasedSettingForAllCallersDto.setLanguage(this.getContext().getUserContext().getLanguage());
        timeBasedSettingForAllCallersDto.setPriority("0"); //Fixed value
        timeBasedSettingForAllCallersDto.setChannelId(this.getContext().getUserContext().getChannelId()); //Fixed value
        timeBasedSettingForAllCallersDto.setServiceId("17"); //Fixed value
        timeBasedSettingForAllCallersDto.setActivityId("1"); //Fixed value
       
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getTimeBasedSettingForAllCallersAPIProcessor()
        .success((timeBasedSettingForAllCallersResponse: TimeBasedSettingForAllCallersResponse)=>
        {
            console.log("success() invoked ##########ALL CALLERS###############");
            this.getAPIModelHandler().onSuccess(timeBasedSettingForAllCallersResponse.getAPIFeature(), 
            timeBasedSettingForAllCallersResponse.getDescription(), timeBasedSettingForAllCallersResponse);
            console.log(JSON.stringify(timeBasedSettingForAllCallersResponse));
         })
        .failure((timeBasedSettingForAllCallersResponse: TimeBasedSettingForAllCallersResponse)=>
         {
           this.getAPIModelHandler().onFailure(timeBasedSettingForAllCallersResponse.getAPIFeature(), 
           timeBasedSettingForAllCallersResponse.getDescription(), undefined);
         })
        .execute(new TimeBasedSettingForAllCallersRequestImpl(timeBasedSettingForAllCallersDto));
    }

    timeBasedSettingForCallersGroupAPI(timeBasedSettingForCallersGroupDto: TimeBasedSettingForCallersGroupDtoImpl): void 
    {
        console.log("timeBasedSettingForCallersGroupAPI() invoked ##########CALLERS GROUP###############");
        timeBasedSettingForCallersGroupDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        timeBasedSettingForCallersGroupDto.setLanguage(this.getContext().getUserContext().getLanguage());
        timeBasedSettingForCallersGroupDto.setPriority("0"); //Fixed value
        timeBasedSettingForCallersGroupDto.setChannelId(this.getContext().getUserContext().getChannelId()); //Fixed value
        timeBasedSettingForCallersGroupDto.setServiceId("2"); //Fixed value
        timeBasedSettingForCallersGroupDto.setActivityId("13"); //Fixed value
        
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getTimeBasedSettingForCallersGroupAPIProcessor()
        .success((timeBasedSettingForCallersGroupResponse: TimeBasedSettingForCallersGroupResponse)=>
        {
            console.log("success() invoked ##########CALLERS GROUP###############");
            this.getAPIModelHandler().onSuccess(timeBasedSettingForCallersGroupResponse.getAPIFeature(), 
            timeBasedSettingForCallersGroupResponse.getDescription(), timeBasedSettingForCallersGroupResponse);
            console.log(JSON.stringify(timeBasedSettingForCallersGroupResponse));
         })
        .failure((timeBasedSettingForCallersGroupResponse: TimeBasedSettingForCallersGroupResponse)=>
         {
           this.getAPIModelHandler().onFailure(timeBasedSettingForCallersGroupResponse.getAPIFeature(), 
           timeBasedSettingForCallersGroupResponse.getDescription(), undefined);
         })
        .execute(new TimeBasedSettingForCallersGroupRequestImpl(timeBasedSettingForCallersGroupDto));
    }

    timeBasedSettingForSpecificCallerAPI(timeBasedSettingForSpecificCallerDto: TimeBasedSettingForSpecificCallerDtoImpl): void 
    {
        console.log("timeBasedSettingForSpecificCallerAPI() invoked ########## SPECIFIC CALLER###############");
        timeBasedSettingForSpecificCallerDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        timeBasedSettingForSpecificCallerDto.setLanguage(this.getContext().getUserContext().getLanguage());
        timeBasedSettingForSpecificCallerDto.setPriority("0"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setChannelId(this.getContext().getUserContext().getChannelId()); //Fixed value
        timeBasedSettingForSpecificCallerDto.setServiceId("13"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setActivityId("1"); //Fixed value
        timeBasedSettingForSpecificCallerDto.setPackName(this.getContext().getUserContext().getPackName());
        
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getTimeBasedSettingForSpecificCallerAPIProcessor()
        .success((timeBasedSettingForSpecificCallerResponse: TimeBasedSettingForSpecificCallerResponse)=>
        {
            console.log("success() invoked ##########SPECIFIC CALLER###############");
            this.getAPIModelHandler().onSuccess(timeBasedSettingForSpecificCallerResponse.getAPIFeature(), 
            timeBasedSettingForSpecificCallerResponse.getDescription(), timeBasedSettingForSpecificCallerResponse);
            console.log(JSON.stringify(timeBasedSettingForSpecificCallerResponse));
         })
        .failure((timeBasedSettingForSpecificCallerResponse: TimeBasedSettingForSpecificCallerResponse)=>
         {
           this.getAPIModelHandler().onFailure(timeBasedSettingForSpecificCallerResponse.getAPIFeature(), 
           timeBasedSettingForSpecificCallerResponse.getDescription(), undefined);
         })
        .execute(new TimeBasedSettingForSpecificCallerRequestImpl(timeBasedSettingForSpecificCallerDto));
    }

    getSearchToneBasedOnId(searchKey: string): void
    {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(0);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        searchToneDto.setToneId(searchKey); 
        searchToneDto.setCategoryId(0);
        searchToneDto.setPageNo(0);

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getToneBasedOnCode()
        .success((searchToneResponse: SearchToneBasedOnCodeResponse)=>
        {
            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), searchToneResponse.getSearchToneDto());

         })
        .failure((searchToneResponse : SearchToneBasedOnCodeResponse)=>
         {
             console.log("--------searchbasedoncode: " + searchToneResponse.getDescription());
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    getGroups(): void {
        let listTonesDto = new ListTonesDtoImpl();
        listTonesDto.setLanguage(this.getContext().getUserContext().getLanguage());
        listTonesDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        listTonesDto.setStartIndex("0");
        listTonesDto.setEndIndex("20");
        listTonesDto.setRbtMode("2");
        
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getListTonesAPIProcessor()
        .success((listTonesResponse: ListTonesResponse)=>
        {
            let groups = listTonesResponse.getListTonesResponseDtos().map((listTonesDtoData: ListTonesDto) =>
            {
                return listTonesDtoData.getGroupDto();
            });
            
            this.getAPIModelHandler().onSuccess(listTonesResponse.getAPIFeature(), 
            listTonesResponse.getDescription(), groups);
         })
        .failure((listTonesResponse : ListTonesResponse)=>
         {
           this.getAPIModelHandler().onFailure(listTonesResponse.getAPIFeature(), 
           listTonesResponse.getDescription(), undefined);
         })
        .execute(new ListTonesRequestImpl(listTonesDto));
    }





    defaultToneAPI(defaultDto:DefaultToneDto): void {
        let dto = new DefaultToneDtoImpl();
        dto.setLanguage(this.getContext().getUserContext().getLanguage());
        dto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        dto.setChannelId("9");
        dto.setPriority("0");
        dto.setServiceId("21");
        dto.setPackName(defaultDto.getPackName());
        dto.setToneId(defaultDto.getToneId());
        
        
        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getDefaultTuneAPIProcessor()
        .success((response: DefaultToneResponse)=>
        {
            this.getAPIModelHandler().onSuccess(response.getAPIFeature(), 
            response.getDescription(), dto);
          
         })
        .failure((response: DefaultToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(response.getAPIFeature(), 
           response.getDescription(), dto);
         })
        .execute(new DefaultToneRequestImpl(dto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/tunesettingsapimodel.ts